module.exports = __webpack_public_path__ + "static/DarksideDetective0-acf9f1d83a086c912d81fe5c1bc7f5c2.webp";